// extracted by mini-css-extract-plugin
module.exports = {"item":"hero-products_item__vPVJY","effect":"hero-products_effect__aRIyo"};